import { createAppProgressLoader } from '@sunlabde/vuelab/src/plugins/AppProgressLoader';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const appProgressLoader = createAppProgressLoader() as any;
